import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      gap: '16px',
    },
    container: {
      flex: 1,
      overflowY: 'auto',
      minHeight: 0,
      padding: '14px 14px',
      border: `1px solid ${colors.color39}`,
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      padding: '14px',
      boxShadow: '0px 2px 9px rgba(0, 0, 0, 0.1)',
      borderRadius: '4px',
      backgroundColor: colors.color5,
      transition: 'all 0.2s ease',
    },
    cardActive: {
      padding: '18px 24px 28px',
    },
    cardHeader: {
      '& .MuiTypography-root': {
        fontSize: '14px',
        fontWeight: '400',
        color: colors.color13,
      },
    },
    cardBody: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    checksRow: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      '& .MuiFormControlLabel-label': {
        fontSize: '13px',
        color: colors.color13,
      },
    },
    checkError: {
      fontSize: '12px',
      color: colors.color19,
      marginBottom: '6px',
      '& span': {
        paddingRight: '4px',
      },
    },
    inputsRow: {
      '& .MuiFormControlLabel-label': {
        fontSize: '13px',
        color: colors.color13,
      },
      '& .MuiTypography-root': {
        fontSize: '13px',
        color: colors.color13,
      },
    },
    defaultButtonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '8px',
    },
    defaultButton: {
      backgroundColor: colors.color13,
      borderRadius: '0px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: colors.color13,
        opacity: 0.95,
      },
    },
    globalError: {
      fontSize: '13px',
      color: colors.color19,
      textAlign: 'center',
      '& span': {
        paddingRight: '4px',
      },
    },
  }
}
